<section
  class="bg-myportal-one flex min-h-[calc(100vh-220px)] flex-col bg-contain bg-top bg-no-repeat p-4 pb-0"
>
  <div
    class="mat-elevation-z8 mx-auto flex w-full max-w-[90rem] flex-col bg-white pb-6 shadow-md"
    [ngClass]="canManageUsers() ? 'rounded-t-3xl' : 'rounded-3xl'"
  >
    <!-- Left column: Info + Roles -->
    <div class="flex w-full">
      <div class="w-1/2">
        <div class="flex items-center justify-between px-6 pt-4">
          <h2 class="text-3xl font-normal">
            {{ loggedInUser()?.Name }}
          </h2>

          <!-- TODO: Uncomment after Okta Engineers enable password change permissions in Okta Stage -->
          <!-- <button
            class="rounded-full bg-gray-100 pt-2 px-2 pb-1 hover:bg-gray-50 hover:text-blue-500 transition-all"
            [matMenuTriggerFor]="accountMenu"
            aria-label="Open account menu"
          >
            <mat-icon >more_vert</mat-icon>
          </button>

          <mat-menu #accountMenu="matMenu">
            <button mat-menu-item (click)="onChangePassword()">
              <mat-icon>lock</mat-icon>
              <span>Change password</span>
            </button>
          </mat-menu> -->
        </div>

        <div class="px-6 pb-6">
          <div class="break-all text-sm text-slate-500 hover:text-slate-700">
            {{ loggedInUser()?.Email }}
          </div>

          <div class="mt-6 flex gap-20">
            <div>
              <div class="text-base">
                {{ loggedInUser()?.Account?.Name || '—' }}
              </div>

              <div
                class="mt-1 text-xs font-normal uppercase tracking-wider text-slate-400"
              >
                Billing Address
              </div>

              <div class="flex gap-2 text-slate-700">
                <mat-icon class="!text-md leading-none text-slate-500"
                  >location_on</mat-icon
                >
                <div class="text-sm">
                  @if (loggedInUser()?.Account?.BillingAddress?.street) {
                    <div>
                      {{ loggedInUser()?.Account?.BillingAddress?.street }}
                    </div>
                    <div>
                      {{ loggedInUser()?.Account?.BillingAddress?.city }},
                      {{ loggedInUser()?.Account?.BillingAddress?.stateCode }}
                      {{ loggedInUser()?.Account?.BillingAddress?.postalCode }}
                    </div>
                  } @else {
                    <div>N/A</div>
                  }
                </div>
              </div>
            </div>

            <!-- Details -->
            <div class="text-sm font-[600]">
              @if (loggedInUser()?.CreatedDate) {
                <div
                  class="text-xs font-normal uppercase tracking-wider text-slate-400"
                >
                  Member Since
                </div>
                <div>
                  {{ loggedInUser().CreatedDate | date: 'MMM d, y' }}
                </div>
              }
              @if (loggedInUser().OktaUsername__c) {
                <div
                  class="mt-2 text-xs font-normal uppercase tracking-wider text-slate-400"
                >
                  Username
                </div>
                <div>{{ loggedInUser().OktaUsername__c }}</div>
              }
              @if (loggedInUser().Portal_Role__r?.Name) {
                <div
                  class="mt-2 text-xs font-normal uppercase tracking-wider text-slate-400"
                >
                  Role
                </div>
                <div>{{ loggedInUser().Portal_Role__r?.Name }}</div>
              }
              @if (loggedInUser().Phone) {
                <div
                  class="mt-2 text-xs font-normal uppercase tracking-wider text-slate-400"
                >
                  Phone
                </div>
                <div>{{ loggedInUser().Phone || '—' }}</div>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="w-1/2" *ngxPermissionsOnly="[Permission.MANAGE_USERS]">
        <h2 class="p-4 pb-2 text-xl">User Roles & Permissions</h2>

        <table class="min-w-full table-auto border-collapse">
          <thead class="bg-gray-100">
            <tr>
              <th class="px-4 py-2 text-left text-xs uppercase">Permission</th>
              @for (role of portalRoles$ | async; track role.Id) {
                <th
                  class="px-4 py-2 text-left text-xs uppercase"
                  [attr.id]="
                    'role-' + (role.Name.split(' ').join('-') | lowercase)
                  "
                >
                  {{ role.Name }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (permission of permissionList; track permission.key) {
              <tr class="border-b odd:bg-gray-50">
                <td class="px-4 py-2 text-sm">{{ permission.label }}</td>
                @for (role of portalRoles$ | async; track role.Id) {
                  <td class="px-4 py-2 text-center opacity-75">
                    <input
                      type="checkbox"
                      [checked]="role?.Permissions__c?.includes(permission.key)"
                      class="pointer-events-none accent-blue-500"
                    />
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <!-- Right column: Users Table -->
    <div
      class="min-h-52 overflow-hidden border-t-2 font-normal"
      *ngxPermissionsOnly="[Permission.MANAGE_USERS]"
    >
      <div
        class="flex w-full items-center justify-between bg-gray-100 px-6 py-4"
      >
        <h2 class="flex w-1/4 text-2xl">
          Manage Users
          {{
            (users$ | async).length > 0
              ? '(' + (users$ | async).length + ')'
              : ''
          }}
        </h2>
        <div class="flex w-2/4 gap-2">
          <!-- Search Input (larger portion) -->
          <input
            type="text"
            placeholder="Search users..."
            class="w-3/4 rounded-xl border border-gray-300 px-4 py-2 text-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            [(ngModel)]="userSearchTerm"
            (ngModelChange)="applyUserSearchFilter()"
          />

          <!-- Role Filter (smaller portion) -->
          <div class="relative w-1/4">
            <select
              id="roleFilter"
              [(ngModel)]="selectedRoleFilter"
              (change)="applyUserSearchFilter()"
              class="peer block w-full cursor-pointer appearance-none rounded-xl border border-gray-300 bg-white px-3 pb-2 pr-10 pt-6 text-sm text-gray-900 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option value="">All Roles</option>
              @for (role of portalRoles$ | async; track role.Id) {
                <option [value]="role.Name">
                  {{ role.Name }}
                </option>
              }
            </select>

            <!-- Floating label -->
            <label
              for="roleFilter"
              class="absolute left-3 top-2 text-xs text-gray-500 transition-all peer-focus:top-1 peer-focus:text-xs peer-focus:text-blue-500"
            >
              Filter by Role
            </label>

            <!-- Mat icon arrow -->
            <mat-icon
              fontSet="material-icons"
              class="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 peer-focus:text-blue-500"
            >
              arrow_drop_down
            </mat-icon>
          </div>
        </div>

        <div class="flex w-1/4 justify-end">
          <button
            class="flex items-center gap-2 rounded-lg bg-cobalt-500 px-4 py-2 text-white shadow-sm hover:bg-cobalt-400"
            (click)="onCreateEditUser()"
          >
            <mat-icon>person_add</mat-icon>
            Invite User
          </button>
        </div>
      </div>
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        matSortActive="FirstName"
        matSortDirection="asc"
      >
        <ng-container matColumnDef="Number">
          <th mat-header-cell *matHeaderCellDef class="uppercase"></th>
          <td
            mat-cell
            *matCellDef="let row; let i = index"
            class="text-sm font-light text-gray-600"
          >
            {{ i + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="UserInfo">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            User
          </th>
          <td mat-cell *matCellDef="let user" class="align-top">
            <div class="flex items-stretch gap-2 py-2">
              <mat-icon class="!h-8 !w-8 text-3xl text-gray-300"
                >account_circle</mat-icon
              >
              <div class="flex flex-col justify-center">
                <div class="text-base">
                  {{ user.LastName }}, {{ user.FirstName }}
                </div>
                <div class="flex items-center text-sm text-gray-400">
                  <mat-icon class="text-sm text-gray-400">mail</mat-icon>
                  <span class="-ml-2 font-normal">{{ user.Email }}</span>
                </div>
                <div class="flex items-center text-sm italic text-gray-400">
                  Created on {{ user.CreatedDate | date: 'MMMM d, y' }}
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Username">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Username
          </th>
          <td mat-cell *matCellDef="let user">{{ user.OktaUsername__c }}</td>
        </ng-container>

        <ng-container matColumnDef="Role">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Role
          </th>
          <td mat-cell *matCellDef="let user">
            @if (user?.Portal_Role__r?.Name) {
              <a
                [routerLink]="[]"
                [fragment]="
                  'role-' +
                  (user.Portal_Role__r?.Name.split(' ').join('-') | lowercase)
                "
                class="text-black"
              >
                {{ user.Portal_Role__r?.Name || '' }}
              </a>
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="LastPortalLogin">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="uppercase"
          >
            Last Login
          </th>
          <td mat-cell *matCellDef="let user">
            <div class="flex">
              @if (user?.LoggedInWithOkta__c) {
                @if (user?.Last_Portal_Login_At__c) {
                  <span>{{
                    user.Last_Portal_Login_At__c | date: 'MMM d, y · h:mm a'
                  }}</span>
                } @else {
                  <span class="italic text-gray-400"
                    >Login history unavailable</span
                  >
                }
              } @else {
                <span class="font-medium text-gray-400"> Never logged in </span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef class="uppercase">Actions</th>
          <td mat-cell *matCellDef="let user">
            <button
              mat-icon-button
              (click)="onCreateEditUser(user)"
              aria-label="Edit user"
              matTooltip="Edit User"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="onDeactivateUser(user)"
              aria-label="Deactivate user"
              matTooltip="Deactivate User"
            >
              <mat-icon>delete</mat-icon>
            </button>
            @if (!user.LoggedInWithOkta__c) {
              <button
                mat-icon-button
                (click)="onResendInvite(user)"
                aria-label="Resend invite"
                matTooltip="Resend Invite"
              >
                <mat-icon>mail</mat-icon>
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="transition-colors duration-150 odd:bg-gray-50 hover:bg-gray-100"
        ></tr>
      </table>

      <!-- No Users Message -->
      @if ((users$ | async).length === 0) {
        <p class="py-2.5 text-center">No users found. Please invite a user.</p>
      }

      <!-- No Search/Filter Resuts Message -->
      @if (
        (users$ | async).length > 0 &&
        !dataSource.filteredData.length &&
        dataSource.filter.length > 0
      ) {
        <p class="py-2.5 text-center">
          No users found
          @if (userSearchTerm && selectedRoleFilter) {
            based on your filter and search selection.
          } @else if (userSearchTerm) {
            based on your search.
          } @else if (selectedRoleFilter) {
            based on your filter selection.
          }
        </p>
      }

      <!-- Paginator -->
      <mat-paginator
        showFirstLastButtons
        [pageSize]="defaultPageSizeOption"
        [pageSizeOptions]="pageSizeOptions"
        [ngClass]="(users$ | async).length === 0 ? 'hidden' : ''"
      ></mat-paginator>
    </div>
  </div>
</section>
